module.exports = __webpack_public_path__ + "static/media/bellabyte-ecommerce-store-site-768x591.c7254e19.jpg";